import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import FormattedHTMLMessage from 'I18n/components/FormattedHTMLMessage';
import UIButton from 'UIComponents/button/UIButton';
import UIIcon from 'UIComponents/icon/UIIcon';
import { getIntentLink } from '../intents/intentSelectors';
import { getSalesExtensionRedirect } from '../intents/SalesExtensionUtils';
import { useLoginRedirect } from '../signup-completed-redirection/useLoginRedirect';
import { useTracker } from '../tracking/useTracker';
import { Step } from '../views/Step';
import { useSelector } from 'react-redux';
import { getIsActiveAndAssignedToVariantONBC008 } from '../store/experiments/selectors';

const CheckYourEmailGoToLoginButton = ({
  email
}) => {
  const tracker = useTracker();
  const intentLink = useSelector(getIntentLink);
  const {
    redirectToLogin
  } = useLoginRedirect();
  const isOnbc008Variant = useSelector(getIsActiveAndAssignedToVariantONBC008);

  if (!email) {
    return null;
  }

  const handleGoToLogin = () => {
    const redirectUrl = getSalesExtensionRedirect(intentLink || '', isOnbc008Variant);
    tracker.signupInteraction('check-you-email-go-to-login');
    redirectToLogin({
      redirectUrl,
      email
    });
  };

  return /*#__PURE__*/_jsxs(UIButton, {
    size: "sm",
    use: "primary",
    onClick: handleGoToLogin,
    children: [/*#__PURE__*/_jsx(UIIcon, {
      name: "locked"
    }), /*#__PURE__*/_jsx(FormattedHTMLMessage, {
      message: `views.${Step.Verification}.salesExtension.goToLoginOnceDone`
    })]
  });
};

export default CheckYourEmailGoToLoginButton;